import { Navigate, useRoutes } from "react-router-dom";
import SignupPage from "./pages/SignupPage";
import ConfirmOtpPage from "./pages/ConfirmOTPPage";
import YourDetails from "./pages/YourDetailsPage";
import ConfirmEmailOtpPage from "./pages/ConfirmEmailOtp";
import PanVerificationPage from "./pages/PanVerificationPage";
import AadhaarKYCPage from "./pages/AadharKYCPage";
import YourProfilePage from "./pages/YourProfilePage";
import LinkUsingIFSC from "./pages/LinkUsingIFSC";
import UploadDocumentsPage from "./pages/UploadDocumentsPage";
import NomineesPage from "./pages/NomineePage";
import EsignPage from "./pages/EsignPage";
import CongratulationsPage from "./pages/CongratulationsPage";
import CameraModule from "./Components/CameraModule/CameraModule";
import WebcamDemo from "./Components/CameraModule/WebCamFaceDetection";
import TradingPreference from "./pages/TradingPreference";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPathName } from "./Components/redux/actions/pathNameActions";
import { useEffect } from "react";
import TermsandConditionsPage from "./pages/TermsandConditionsPage";
import CompletedPage from "./pages/CompletedPage";
import PageNotFound from "./pages/PageNotFound";
import PANCR from "./pages/PanCRDigilocker";
import HomePage from "./Pages copy/HomePage";
import HomePageEsign from "./Pages copy/esign/HomePageEsign";
import FetchIncomeProof from "./pages/FetchIncomeProof";
import SuccessPage from "./Pages copy/SuccessPage";
import SuccessEsignPage from "./Pages copy/esign/SuccessEsignPage";
import Email from "./pages/YourDetailsPage";
import Onboarding from "./pages/Onboarding";

export default function Router() {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPathName(pathName));
  }, [pathName]);

  const routes = useRoutes([
    {
      path: "",
      element: <SignupPage />,
    },
    {
      path: "onboarding",
      element: <Onboarding />,
    },
    {
      path: "token/:id",
      element: <SignupPage />,
    },
    {
      path: "confirm_otp",
      element: <ConfirmOtpPage />,
    },
    {
      path: "email",
      element: <Email />,
    },
    {
      path: "confirmemailotp",
      element: <ConfirmEmailOtpPage />,
    },

    {
      path: "panverification",
      element: <PanVerificationPage />,
    },
    {
      path: "aadhaar",
      element: <AadhaarKYCPage />,
    },
    {
      path: "tradingPreference",
      element: <TradingPreference />,
    },
    {
      path: "profile",
      element: <YourProfilePage />,
    },
    {
      path: "bank",
      element: <LinkUsingIFSC />,
    },
    {
      path: "ipv",
      element: <WebcamDemo />,
    },

    {
      path: "uploaddocuments",
      element: <UploadDocumentsPage />,
    },
    {
      path: "nominee",
      // element: <NewNominee />
      element: <NomineesPage />,
    },
    {
      path: "esign",
      element: <EsignPage />,
    },

    // {
    //   path: "termsandconditions",
    //   element: <TermsandConditionsPage />,
    // },
    {
      path: "pancr/*",
      element: <PANCR />,
    },
    {
      path: "account_aggregator/*",
      element: <FetchIncomeProof />,
    },
    {
      path: "ekyc_aadhaar/*",
      element: <SuccessPage />,
    },
    {
      path: "ekyc_esign/*",
      element: <SuccessEsignPage />,
    },
    {
      path: "/*",
      element: <PageNotFound />,
    },

    {
      path: "congratulations",
      element: <CongratulationsPage />,
    },
    {
      path: "completed",
      element: <CompletedPage />,
    },
  ]);

  return routes;
}
